import { VOUCHER_TYPE } from '@src/constants/voucher';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { formatNumberWithSuffix } from '@src/services/package';

const InfoVoucher = ({
  bestVoucher,
  isVietNam,
  language,
  newPricingOverviewEnabled,
}) => {
  const { t } = useTranslation();

  if (bestVoucher?.type === VOUCHER_TYPE.PERCENT) {
    return `-${bestVoucher?.value}%`;
  }
  if (bestVoucher?.type === VOUCHER_TYPE.PRICE) {
    return (
      <div>
        <span style={{ marginRight: '1px' }}>-</span>
        <span
          className={`unit-price-info-voucher ${isVietNam ? 'underlined' : ''}`}
        >
          {isVietNam ? 'đ' : '$'}
        </span>
        {bestVoucher?.value?.toLocaleString(language)}
      </div>
    );
  }
  if (bestVoucher?.type === VOUCHER_TYPE.CHARACTER) {
    return t(newPricingOverviewEnabled ? 'xCreditsV2' : 'xCredits', {
      value: bestVoucher?.value?.toLocaleString(language),
    });
  }
  if (bestVoucher?.type === VOUCHER_TYPE.FIXED_CHARACTER) {
    return t(newPricingOverviewEnabled ? '+credits' : '+chars', {
      value: formatNumberWithSuffix(bestVoucher?.value, language),
    });
  }
  if (bestVoucher?.type === VOUCHER_TYPE.TIME) {
    return t('freeMonth', { value: bestVoucher?.value });
  }
  return '';
};

export default InfoVoucher;
